if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.initOverlay();
      this.initHeaderActions();
      this.setHeaderCartIconAccessibility();
    }

    initOverlay() {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.removeEventListener('click', this.closeHandler);
        this.closeHandler = this.close.bind(this);
        overlay.addEventListener('click', this.closeHandler);
      }
    }

    initHeaderActions() {
      // Clear Cart button handler
      const clearBtn = this.querySelector('.js-clear-cart');
      if (clearBtn) {
        clearBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (confirm('Are you sure you want to clear your cart?')) {
            fetch(`${routes.cart_clear_url || '/cart/clear.js'}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
            })
            .then(() => {
              if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer' });
              } else {
                this.refreshCart();
              }
            })
            .catch(err => console.error(err));
          }
        });
      }

      // Share Cart button handler
      const shareBtn = this.querySelector('.js-share-cart');
      if (shareBtn) {
        shareBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (navigator.share) {
            navigator.share({
              title: document.title,
              url: window.location.href
            }).catch(() => {});
          } else if (navigator.clipboard) {
            navigator.clipboard.writeText(window.location.href)
              .then(() => alert('Cart link copied to clipboard!'))
              .catch(() => {});
          }
        });
      }
    }

    refreshCart() {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then(res => res.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceDrawer = html.querySelector('cart-drawer');
          if (sourceDrawer) {
            this.innerHTML = sourceDrawer.innerHTML;
            this.className = sourceDrawer.className;
            this.classList.add('active');
            this.initOverlay();
            this.initHeaderActions();
          }
        });
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (this.classList.contains('active')) return;
      if (triggeredBy) this.setActiveElement(triggeredBy);

      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      document.body.classList.add('overflow-hidden');
      this.querySelector('cart-drawer-items')?.dispatchViewEvent();
    }

    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      }
      document.body.classList.remove('overflow-hidden');
    }

    renderContents(parsedState) {
      this.classList.contains('is-empty') && this.classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      setTimeout(() => {
        this.initOverlay();
        this.initHeaderActions();
        this.open();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items')) {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}
